import ThemeController from 'shared-assets/lib/utils/controllers/ThemeController';

(function () {
  angular
    .module('kareo.ui.shared.directives.product.k-product-picker-view', [
      'kareo.ui.shared.directives.product.k-product-picker-view.url-for',
      'ngCookies',
    ])
    .component('kProductPickerView', {
      bindings: {
        visibleProducts: '<',
        products: '=',
        onSelect: '&?',
        onLearnMore: '&?',
        learnMoreTarget: '@?',
        isReadOnly: '<?',
        isTebraPackage: '<?',
        includedProductKeys: '<?',
      },
      controller,
      controllerAs: 'vm',
      template: require('./k-product-picker-view.pug')()
    })
    .controller('ThemeController', ThemeController);

  controller.$inject = ['$window', 'UrlForProductPicker'];
  function controller($window, UrlFor) {
    const vm = this;

    vm.$onInit = init;
    vm.productSelected = productSelected;

    function init() {
      /*
          TO-DO 5.2.16
          Update the products binding to be productStatus from providerInfo instead of products.
          productStatus has all the info that we need and we should use that object for saving changes.
          Remove productStatus when that is complete.
      */
      vm.products = vm.products || {};

      vm.visibleProducts = vm.visibleProducts || {};

      vm.includedProductKeys = vm.includedProductKeys || [];

      let { products, count } = getProductsToShow(vm.visibleProducts, vm.includedProductKeys);
      
      vm.productsToShow = products;
      vm.productCount = count;
    }

    vm.productCategoriesMapping = {
      KAREO_EHR: 'Clinical',
      KAREO_OFFICE: 'Engage',
      DOCTORBASE: 'Engage',
      RCM: 'Managed Billing',
      PM: 'Billing',
      KAREO_TELEHEALTH: 'Telehealth',
      AI_NOTE_ASSIST: 'AI Note Assist Subscription',
    };

    vm.productCategoriesMappingForTebra = {
      KAREO_EHR: 'Clinical',
      KAREO_OFFICE: 'Patient Experience' ,
      DOCTORBASE: 'Patient Experience',
      RCM: 'Managed Billing',
      PM: 'Billing',
      KAREO_TELEHEALTH: 'Telehealth',
      AI_NOTE_ASSIST: 'AI Note Assist Subscription',
    };

    vm.learnMoreClicked = learnMoreClicked;
    vm.getProductCategory = getProductCategory;

    function learnMoreClicked(productName, productDetails) {
      if (typeof vm.onLearnMore === 'function') {
        const condensedProduct = angular.copy(productDetails);
        condensedProduct.name = productName;
        vm.onLearnMore(condensedProduct);
      } else {
        const target = vm.learnMoreTarget ? vm.learnMoreTarget : '_blank';
        $window.open(UrlFor.solutionCenterProduct(productName), target);
      }
    }

    function getProductCategory(productName) {
      return vm.isTebraPackage ? vm.productCategoriesMappingForTebra[productName] || '' : vm.productCategoriesMapping[productName] || '';
    }

    function productSelected(selected) {
      if (vm.onSelect) {
        vm.onSelect({selected});
      }
    }

    function getProductsToShow(visibleProducts, includedProductKeys) {
      const includedSet = new Set(includedProductKeys);
      
      const products = Object.keys(visibleProducts)
        .filter(key => includedSet.has(key))
        .reduce((acc, key) => {
          acc[key] = visibleProducts[key];
          return acc;
        }, {});
      
      return {
        products,
        count: Object.keys(products).length
      };
    }
  }
})();
